import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { motion } from "framer-motion";

const proceedingTypes = [
  { id: "deposition", label: "Deposition" },
  { id: "trial", label: "Trial" },
  { id: "court-hearing", label: "Court Hearing" },
  { id: "arbitration", label: "Arbitration" },
  { id: "meeting", label: "Meeting" },
  { id: "other", label: "Other" },
];

export default function ProceedingSelector({ selected, onSelect, otherText, onOtherTextChange }) {
  return (
    <div>
      <Label className="text-[#F5F5F7] text-sm mb-4 block" style={{ fontFamily: 'JetBrains Mono, monospace' }}>
        Type of Proceeding *
      </Label>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
        {proceedingTypes.map((type) => (
          <div
            key={type.id}
            className={`flex items-center justify-center p-3 border cursor-pointer transition-all ${
              selected === type.id ? "border-[#E8E8E8] bg-[#E8E8E8]/10" : "border-[#333333] hover:border-[#E8E8E8]/50"
            }`}
            onClick={() => onSelect(type.id)}
            data-testid={`proceeding-${type.id}`}
          >
            <span className="text-[#F5F5F7] text-sm">{type.label}</span>
          </div>
        ))}
      </div>
      {selected === "other" && (
        <motion.div initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: "auto" }} className="mt-4">
          <Input
            type="text" placeholder="Please specify the type of proceeding..." value={otherText}
            onChange={(e) => onOtherTextChange(e.target.value)}
            className="rounded-none bg-[#1A1A1A] border-[#333333] text-[#F5F5F7] placeholder:text-[#E0E0E0]/50 focus:border-[#E8E8E8] focus:ring-1 focus:ring-[#E8E8E8]"
            data-testid="other-proceeding-input"
          />
        </motion.div>
      )}
    </div>
  );
}
